import { createFileRoute } from "@tanstack/react-router";

import { FacebookAdsFormPage } from "~/pages/connection-new/facebook-ads-form.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/new/_connection/facebook_ads",
)({
  component: FacebookAdsFormPage,
});
